import template from './descriptiveBox.html';

export const descriptiveBoxComponent = {
  name: 'descriptiveBox',
  restrict: 'E',
  transclude: true,
  template,
  controllerAs: 'vm',
  bindings: {
    title: '@',
    subtitle: '@',
    descriptionTitle: '@',
    descriptionSubtitle: '@'
  }
};
